const actions = {
    PURCHASE_SETTLEMENT_DETAILS_START: 'PURCHASE_SETTLEMENT_DETAILS_START',
    PURCHASE_SETTLEMENT_DETAILS_SUCCESS: 'PURCHASE_SETTLEMENT_DETAILS_SUCCESS',
    PURCHASE_SETTLEMENT_DETAILS_FAILURE: 'PURCHASE_SETTLEMENT_DETAILS_FAILURE',


    OPEN_INVOICE_DETAILS_START: 'OPEN_INVOICE_DETAILS_START',
    OPEN_INVOICE_DETAILS_SUCCESS: 'OPEN_INVOICE_DETAILS_SUCCESS',
    OPEN_INVOICE_DETAILS_FAILURE: 'OPEN_INVOICE_DETAILS_FAILURE',

    OPEN_PAYMENT_DETAILS_START: 'OPEN_PAYMENT_DETAILS_START',
    OPEN_PAYMENT_DETAILS_SUCCESS: 'OPEN_PAYMENT_DETAILS_SUCCESS',
    OPEN_PAYMENT_DETAILS_FAILURE: 'OPEN_PAYMENT_DETAILS_FAILURE',


    CLOSE_INVOICE_DETAILS_START: 'CLOSE_INVOICE_DETAILS_START',
    CLOSE_INVOICE_DETAILS_SUCCESS: 'CLOSE_INVOICE_DETAILS_SUCCESS',
    CLOSE_INVOICE_DETAILS_FAILURE: 'CLOSE_INVOICE_DETAILS_FAILURE',

    CLOSE_PAYMENT_DETAILS_START: 'CLOSE_PAYMENT_DETAILS_START',
    CLOSE_PAYMENT_DETAILS_SUCCESS: 'CLOSE_PAYMENT_DETAILS_SUCCESS',
    CLOSE_PAYMENT_DETAILS_FAILURE: 'CLOSE_PAYMENT_DETAILS_FAILURE'
};

export default actions;